<template>
  <div class="menu">
    <div id="fixed" class="fixed">
      <nav class="navbar navbar-expand-lg navbar-dark bg-dark">
        <div class="container-fluid">
          <a class="navbar-brand" href="/">
            <img src="https://smartclic.pe/wp-content/uploads/2021/09/Logo-Oficial-Smart-Clic-blanco.png" alt=""
              width="72">
          </a>
          <button class="navbar-toggler" type="button" data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false"
            aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
          </button>
          <div class="collapse navbar-collapse" id="navbarSupportedContent">
            <ul class="navbar-nav me-auto mb-2 mb-lg-0">
              <li class="nav-item">
                <a class="nav-link active" aria-current="page" href="/">Inicio</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="https://es.cooltext.com/Download-Font-Teen" target="_blank">Crear Logo</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="https://e-consultaruc.sunat.gob.pe/cl-ti-itmrconsruc/jcrS00Alias"
                  target="_blank">Consulta RUC</a>
              </li>
            </ul>
            <div class="d-flex">
              <div v-if="isLoggedIn" class="input-group">
                <button class="btn btn-outline-secondary dropdown-toggle" type="button" data-bs-toggle="dropdown"
                  aria-expanded="false">
                  {{ usuario.name }}
                </button>
                <ul class="dropdown-menu dropdown-menu-end">
                  <li v-if="usuario.rol == roles.ADMINISTRADOR">
                    <RouterLink to="/usuarios" class="dropdown-item">Usuarios</RouterLink>
                  </li>
                  <li v-else><a href="/" class="dropdown-item disabled">Usuarios</a></li>
                  <li>
                    <RouterLink to="/actualizar-usuario" class="dropdown-item">Editar mi usuario</RouterLink>
                  </li>
                  <li>
                    <hr class="dropdown-divider">
                  </li>
                  <li><a class="dropdown-item" @click="btnCerrarSesion">Cerrar Sesión</a></li>
                </ul>
              </div>
              <RouterLink v-else to="/login"><button class="btn btn-outline-secondary" type="button">Iniciar
                  Sesión</button></RouterLink>
            </div>
          </div>
        </div>
      </nav>
    </div>
  </div>
</template>

<script>
import { Rol } from '@/constants/global';
import authService from '@/services/auth.service';

export default {
  name: 'ToolBar',
  data() {
    return {
      usuario: authService.getUser(),
      roles: Rol,
      isLoggedIn: authService.isLoggedIn()
    };
  },
  methods: {
    btnCerrarSesion(){
      authService.logout();
      this.isLoggedIn = false;
      this.$router.push({
        path: '/bienvenida'
      });
      
    }
  }
}
</script>

<style scoped>

</style>
